import { useState } from 'react';
import { Dialog } from '@dreamtree-org/twreact-ui';
import PageHero from '@/components/site/PageHero';
import SectionHeading from '@/components/site/SectionHeading';
import CtaBand from '@/components/site/CtaBand';
import Testimonials from '@/components/sections/Testimonials';
import GoogleReviews from '@/components/sections/GoogleReviews';
import { certificates } from '@site/data';
import { usePage } from '@site/content';
import { useClients } from '@api/public';

export default function Clients() {
  const { hero, logos, letters } = usePage('clients');
  const home = usePage('home');
  const clients = useClients();
  const [active, setActive] = useState(null);

  return (
    <>
      <PageHero {...hero} seoTitle="Clients & Testimonials" />

      <section className="py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={logos.eyebrow} title={logos.title} />
          <ul className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {clients.map((c) => (
              <li key={c.alt} className="flex aspect-[3/2] items-center justify-center overflow-hidden rounded-xl border border-[var(--app-border)] bg-white p-2 shadow-sm transition-shadow hover:shadow-md">
                <img src={c.src} alt={c.alt} loading="lazy" className="max-h-full max-w-full object-contain" />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <GoogleReviews className="bg-white" />

      <div className="bg-ink-50">
        <Testimonials eyebrow={home.testimonials.eyebrow} title={home.testimonials.title} />
      </div>

      <section className="py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={letters.eyebrow} title={letters.title} text={letters.text} />
          <ul className="mt-12 columns-2 gap-4 sm:columns-3 lg:columns-4">
            {certificates.map((c) => (
              <li key={c.src} className="mb-4 break-inside-avoid">
                <button
                  type="button"
                  onClick={() => setActive(c)}
                  className="block w-full overflow-hidden rounded-xl border border-[var(--app-border)] bg-white p-1.5 shadow-sm transition-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
                  aria-label={`Open ${c.alt}`}
                >
                  <img src={c.src} alt={c.alt} loading="lazy" className="w-full rounded-lg" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <Dialog isOpen={active !== null} onClose={() => setActive(null)} title="Letter of appreciation" size="xl">
        {active && <img src={active.src} alt={active.alt} className="max-h-[75vh] w-full rounded-xl object-contain" />}
      </Dialog>

      <CtaBand />
    </>
  );
}
